import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';
import { MessageService } from 'primeng/components/common/messageservice';
import { FileServiceImpl } from '../../../../../shared/services/file.service';

@Component({
  selector: 'fes-fes-workflow-action-process-add-manuscript-history',
  templateUrl: './fes-workflow-action-process-add-manuscript-history.component.html',
  styleUrls: ['./fes-workflow-action-process-add-manuscript-history.component.scss']
})
export class FesWorkflowActionProcessAddManuscriptHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

  files: any[] = [];

  constructor(
    private messageService: MessageService,
    private fileService: FileServiceImpl
  ) {
    super();
  }

  payloadChanged(payload) {
    if (payload && payload.files && Array.isArray(payload.files)) {

      this.files = [];
      payload.files.forEach(file => {
        this.files.push({
          displayName: file.originalFileName,
          id: file.fileId
        });
      });

    }
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onDownloadClicked(event: any) {
    this.fileService.downloadFile(
      event.id
    );
  }
}
